import React, { Component } from 'react';
import Constants from '../../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import toastr from 'toastr';

import Select from './select';
import TextBox from './textBox';

const initialObjectState = {
  id: "",
  label: "",
  format: ""
}

class ObjectMetricVirtualMarksLabelEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState),      
      toEditObjectPosition: null,   
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    };
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  isValidObject = (object) => {
    let trimedLabel = object.label.trim();
    let trimedId = object.id.trim();
    if(trimedLabel == "" || trimedId== "") {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(intl.formatMessage({ id: "metricAdmin.fields.virtual_marks_labels_empty_error"}),"");
      return false;
    }
    return true;
  };
    
  handleAddButtonClick = (event) => {
    if(this.editItemInput) {
      this.editItemInput.focus();
    }
  };

  handleCancelAdd = (event) => {
    this.setState({
      showOverlay: false,
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
  };

  handleChangeAddItem = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toAddObject = JavascriptUtilsTooling.deepCopy(this.state.toAddObject);
    toAddObject[event.currentTarget.dataset.path] = value;
    this.setState({
      showOverlay: true,
      toAddObject: toAddObject
    });    
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }  
  };

  handleSaveAddItem = (event) => {
    if(this.isValidObject(this.state.toAddObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });
    }
  };

  handleClickEdit = (event) => {
    let itemIndex = event.currentTarget.dataset.index;    
    let objectToEdit = JSON.parse(event.currentTarget.dataset.value);
    this.setState({     
      showOverlay: true, 
      toEditObjectPosition: itemIndex,
      toEditObject: objectToEdit
    });
  };

  handleChangeEdit = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toEditObject = JavascriptUtilsTooling.deepCopy(this.state.toEditObject);
    toEditObject[event.currentTarget.dataset.path] = value;
    this.setState({
      toEditObject: toEditObject
    });  
  };

  handleCancelEdit = (event) => {
    this.setState({
      showOverlay: false,
      toEditObjectPosition: null,
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
  };

  handleSaveEditItem = (event) => {
    if(this.isValidObject(this.state.toEditObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toEditObjectPosition: null,
        toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });   
    }     
  };

  handleOnEnterEditItem = (event) => {
    if(this.editItemSaveButton) {
      this.editItemSaveButton.click();      
    }   
  };

  render() {
    const {
      className,
      values,
      onChange,
      disabled
    } = this.props;
    const dataPath = this.props["data-path"];
    return (
      <div className={"custom-input free-text-list select-list object-editor object-metric-virtual-marks-label-editor" + (className ? " " + className : "") + " select-list-no-search" + (className ? " " + className : "") + " select-list-no-search" + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
        {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
        <div className="free-text-list-label">
          <FormattedMessage id="metricAdmin.fields.virtual_marks_labels"/>
          {!disabled && (<i className="fas fa-plus-circle" onClick={this.handleAddButtonClick}/>)}
        </div>
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
              if(this.state.toEditObjectPosition == i) {
                return (
                  <div key={i} className="free-text-list-list-item free-text-list-list-item-edit">
                    <div className="free-text-list-list-item-inner object-editor-inputs">
                      <div className="object-editor-inputs-linebreak"> 
                        <TextBox
                          className="free-text-list-list-edit-item object-metric-virtual-marks-label-editor-id-input"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeEdit}
                          data-path={"id"}
                          value={this.state.toEditObject.id}
                          onKeyEsc={this.handleCancelEdit}
                          onKeyEnter={this.handleOnEnterEditItem}
                          type={Constants.interface.inputs.type.TEXT}
                          labelLocale={<FormattedMessage id="metricAdmin.fields.virtualMarksLabels.id"/>}
                        />
                        <TextBox
                          className="free-text-list-list-edit-item object-metric-virtual-marks-label-editor-label-input"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeEdit}
                          data-path={"label"}
                          value={this.state.toEditObject.label}
                          onKeyEsc={this.handleCancelEdit}
                          onKeyEnter={this.handleOnEnterEditItem}
                          type={Constants.interface.inputs.type.TEXT}
                          labelLocale={<FormattedMessage id="metricAdmin.fields.virtualMarksLabels.label"/>}
                        />
                        <TextBox
                          className="free-text-list-list-edit-item object-metric-virtual-marks-label-editor-format-input"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeEdit}
                          data-path={"format"}
                          value={this.state.toEditObject.format}
                          onKeyEsc={this.handleCancelEdit}
                          onKeyEnter={this.handleOnEnterEditItem}
                          type={Constants.interface.inputs.type.TEXT}
                          labelLocale={<FormattedMessage id="metricAdmin.fields.virtualMarksLabels.format"/>}
                        />
                      </div>
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-edit">
                        <i 
                          ref={(input) => { this.editItemSaveButton = input; }}
                          className="fas fa-save"
                          data-index={i}                        
                          data-value={JSON.stringify(this.state.toEditObject)}
                          data-objecteditor={"true"}
                          data-path={dataPath}
                          data-edit={"true"}
                          onClick={this.handleSaveEditItem}                      
                        />         
                        <i className="fas cancel-action fa-times-circle" onClick={this.handleCancelEdit}/>
                      </div>
                    )}
                  </div>
                );
              }
              else {
                let itemInnerText = item.id + " -> " + item.label + (item.format.trim()!="" ? " (" + item.format + ")" : "");
                return (
                  <div key={i} className="free-text-list-list-item">
                    <div title={itemInnerText} className="free-text-list-list-item-inner">
                      {itemInnerText}
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons">
                        <i 
                          className="fas fa-edit"
                          onClick={this.handleClickEdit}
                          data-index={i}
                          data-value={JSON.stringify(item)}
                        />
                        <i
                          className="fas delete-action fa-trash"                          
                          data-index={i}
                          data-delete={"true"}
                          data-objecteditor={"true"}
                          data-value={JSON.stringify(item)}
                          data-path={dataPath}
                          onClick={onChange}
                        />
                      </div>
                    )}
                  </div>
                );
              }
            })}
            <div className="free-text-list-list-item free-text-list-list-item-add">
              <div className="free-text-list-list-item-inner">
                {!disabled && (
                  <div className="object-editor-inputs">
                    <div className="object-editor-inputs-linebreak">
                      <TextBox
                        className="free-text-list-list-edit-item object-metric-virtual-marks-label-editor-id-input"
                        styleType={Constants.interface.inputs.styleType.OUTLINED}
                        onChange={this.handleChangeAddItem}
                        data-path={"id"}
                        value={this.state.toAddObject.id}
                        onKeyEsc={this.handleCancelAdd}
                        onKeyEnter={this.handleOnEnterAddItem}
                        type={Constants.interface.inputs.type.TEXT}
                        labelLocale={<FormattedMessage id="metricAdmin.fields.virtualMarksLabels.id"/>}
                        ref={(input) => { this.editItemInput = input; }}
                      />
                      <TextBox
                        className="free-text-list-list-edit-item object-metric-virtual-marks-label-editor-label-input"
                        styleType={Constants.interface.inputs.styleType.OUTLINED}
                        onChange={this.handleChangeAddItem}
                        data-path={"label"}
                        value={this.state.toAddObject.label}
                        onKeyEsc={this.handleCancelAdd}
                        onKeyEnter={this.handleOnEnterAddItem}
                        type={Constants.interface.inputs.type.TEXT}
                        labelLocale={<FormattedMessage id="metricAdmin.fields.virtualMarksLabels.label"/>}
                      />
                      <TextBox
                        className="free-text-list-list-edit-item object-metric-virtual-marks-label-editor-format-input"
                        styleType={Constants.interface.inputs.styleType.OUTLINED}
                        onChange={this.handleChangeAddItem}
                        data-path={"format"}
                        value={this.state.toAddObject.format}
                        onKeyEsc={this.handleCancelAdd}
                        onKeyEnter={this.handleOnEnterAddItem}
                        type={Constants.interface.inputs.type.TEXT}
                        labelLocale={<FormattedMessage id="metricAdmin.fields.virtualMarksLabels.format"/>}
                      />
                    </div>
                  </div>
                )}
              </div>
              {!disabled && (
                <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-add">
                  <i 
                    ref={(input) => { this.addItemSaveButton = input; }}
                    className="fas fa-save"
                    data-objecteditor={"true"}
                    data-value={JSON.stringify(this.state.toAddObject)}
                    data-path={dataPath}
                    onClick={this.handleSaveAddItem}   
                  />
                  <i 
                    className="fas cancel-action fa-times-circle"
                    onClick={this.handleCancelAdd}
                  />
                </div>
              )}
            </div>
          </div>
      </div>
    );
  }
}

export default ObjectMetricVirtualMarksLabelEditor;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/objectMetricVirtualMarksLabelEditor.jsx